<template>
    <b-modal id="editMobileModal" hide-backdrop centered v-bind:title="mobileSettingsTitle" ok-title="Update"
            @ok="updateMobSettings" @hidden="editMobileModal" @cancel="editMobileModal" @shown="updateMobileSettings(tenant)">
            <b-form ref="form">
              <b-form-group>
                <label class="checkbox-container">
                  Disable idle timeout
                  <input type="checkbox" :value="disableIdleTimeout" id="disableIdleTimeout" v-model="disableIdleTimeout" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Disable Biometric Authentication
                  <input type="checkbox" :value="disableBiometricAuthentication" id="disableBiometricAuthentication"
                    v-model="disableBiometricAuthentication" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Force Refresh Token
                  <input type="checkbox" :value="forceRefreshToken" id="forceRefreshToken" v-model="forceRefreshToken" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Force Change Date To Current Date In Entrance
                  <input type="checkbox" :value="forceChangeDateToCurrentDateInEntrance"
                    id="forceChangeDateToCurrentDateInEntrance" v-model="forceChangeDateToCurrentDateInEntrance" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Enable Timer Entrance Activity
                  <input type="checkbox" :value="enableTimerInEntranceActivity" id="enableTimerInEntranceActivity"
                    v-model="enableTimerInEntranceActivity" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group label="Entrance Activity Refresh Rate in Seconds"
                label-for="entranceActivityRefreshRateInSeconds">
                <b-form-input id="entranceActivityRefreshRateInSeconds"
                  v-model="entranceActivityRefreshRateInSeconds"></b-form-input>
                <b-form-group label="Logout Display Text" label-for="logoutDisplayText" class="mt-2">
                  <b-form-input id="logoutDisplayText" v-model="logoutDisplayText"></b-form-input>
                </b-form-group>
                <b-form-group label="Idle timeout in seconds" label-for="idleTimeoutInSeconds">
                  <b-form-input id="idleTimeoutInSeconds" v-model="idleTimeoutInSeconds"></b-form-input>
                </b-form-group>
              </b-form-group>
              <!--  <b-form-group label="Custom High Temp Status" label-for="tempStatus">
              <b-form-input id="tempStatus" v-model="tempStatus"></b-form-input>
              </b-form-group>-->
              <!--  <b-form-group label="Qr_code_expiry" label-for="qr_code_expiry">
              <b-form-input id="qr_code_expiry" v-model="qr_code_expiry"></b-form-input>
              </b-form-group>-->
            </b-form>
          </b-modal>
</template>
<script>

import Vue from "vue";
export default{

    data(){
        return{
            mobileSettingsTitle:"",
            disableIdleTimeout: false,
            idleTimeoutInSeconds: 1200,
            disableBiometricAuthentication: true,
            forceRefreshToken: true,
            forceChangeDateToCurrentDateInEntrance: false,
            enableTimerInEntranceActivity: false,
            entranceActivityRefreshRateInSeconds: 30,
            logoutDisplayText: "Session expired, please re-login.",
            preventPTTSS: false,
            errorMessage:"",
            lastTenant:""



        }
    },
    props:['tenant','tenants'],
    methods:{
        async updateMobileSettings(tenant) {
        this.tenants;
        this.lastTenant = tenant.name;
        this.mobileSettingsTitle = "Tenant Mobile Configuration - " + tenant.name;
        this.mobileSettingsObj
        this.disableBiometricAuthentication =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.disableBiometricAuthentication
                ? tenant.mobileSettings.disableBiometricAuthentication
                : false;
        this.disableIdleTimeout =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.disableIdleTimeout
                ? tenant.mobileSettings.disableIdleTimeout
                : false;
        this.forceChangeDateToCurrentDateInEntrance =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.forceChangeDateToCurrentDateInEntrance
                ? tenant.mobileSettings.forceChangeDateToCurrentDateInEntrance
                : false;
        this.forceRefreshToken =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.forceRefreshToken
                ? tenant.mobileSettings.forceRefreshToken
                : false;
        this.enableTimerInEntranceActivity =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.enableTimerInEntranceActivity
                ? tenant.mobileSettings.enableTimerInEntranceActivity
                : false;
        this.logoutDisplayText =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.logoutDisplayText
                ? tenant.mobileSettings.logoutDisplayText
                : "Session expired, please re-login.";
        this.idleTimeoutInSeconds =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.idleTimeoutInSeconds
                ? tenant.mobileSettings.idleTimeoutInSeconds
                : 1200;
        this.entranceActivityRefreshRateInSeconds =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.entranceActivityRefreshRateInSeconds
                ? tenant.mobileSettings.entranceActivityRefreshRateInSeconds
                : 30;
        this.preventPTTSS =
            tenant &&
            tenant.mobileSettings &&
            tenant.mobileSettings.preventPTTSS
                ? tenant.mobileSettings.preventPTTSS
                : false
      },
        async updateMobSettings(command, args, when) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.TENET_SERVICE +
            `/tenants/${this.lastTenant}/updateMobileSettings`;
        var tenants_settings_request = new Request(url, {
          method: "PATCH",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            otherMobileSettings: {
              logoutDisplayText: this.logoutDisplayText,
              disableIdleTimeout: this.disableIdleTimeout,
              idleTimeoutInSeconds: this.idleTimeoutInSeconds,
              disableBiometricAuthentication: this.disableBiometricAuthentication,
              forceRefreshToken: this.forceRefreshToken,
              forceChangeDateToCurrentDateInEntrance:
              this.forceChangeDateToCurrentDateInEntrance,
              enableTimerInEntranceActivity: this.enableTimerInEntranceActivity,
              entranceActivityRefreshRateInSeconds:
              this.entranceActivityRefreshRateInSeconds,
            },
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var tenantSettingsResponse = await fetch(tenants_settings_request);
          if (tenantSettingsResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
  
            Vue.$toast.open({message: this.errorMessage, type: "error"});
  
            return;
          }
          if (tenantSettingsResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (tenantSettingsResponse.status == 503) {
            return this.updateMobSettings(command, args, when);
          }
          if (tenantSettingsResponse.status != 200) {
            (this.errorMessage = "Error occurred to "),
                command.command,
                " :",
                tenantSettingsResponse.status;
  
            this.commandError = "Failed to update Mobile Configuration";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["logoutDisplayText"] = this.logoutDisplayText;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["disableIdleTimeout"] = this.disableIdleTimeout;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["idleTimeoutInSeconds"] = this.idleTimeoutInSeconds;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["disableBiometricAuthentication"] =
                this.disableBiometricAuthentication;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["forceRefreshToken"] = this.forceRefreshToken;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["forceChangeDateToCurrentDateInEntrance"] =
                this.forceChangeDateToCurrentDateInEntrance;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["enableTimerInEntranceActivity"] =
                this.enableTimerInEntranceActivity;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "mobileSettings"
                ]["entranceActivityRefreshRateInSeconds"] =
                this.entranceActivityRefreshRateInSeconds;
            this.commandError = "";
            Vue.$toast.open({
              message: "Successfully Updated Tenant Mobile Configuration",
              type: "success",
            });
          }
        } catch (tex) {
          this.commandError = "Failed! due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
        //  this.fetchData();
      },
      
      editMobileModal() {
        this.$bvModal.hide("editMobileModal");
      },
    }
}
</script>
<style scoped lang="scss">
  @import "../../style.scss";

.checkbox-container {
      color: #6a6a6a;
      font-family: GTWalsheimPro-Regular;
    }
html input[disabled]~.checkmark {
    opacity: 0.5;
}
</style>